import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'STATISTIC',
    entityName: 'STATISTIC',
});

const initialState = {
    ...crudInitialState,
    deletedStatistic: {},
    deleting: false,
    saving: false,
    columns: [],
    location: "/dashboard/asset-overview"
};
const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }

    // Handle other actions
    switch (action.type) {
        case 'HANDLE_DRAGGED_SET':
            return { ...state, columns: action.columns }
        case 'HANDLE_SET_LOCATION':
            return { ...state, location: action.location }
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
